import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { dataStore } from 'src/app/app.component';
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { NgStyle } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  imports: [
    NgStyle,
    MatButton,
    RouterLink,
    LoginComponent,
    RegisterComponent,
    ResetPasswordComponent,
    MatProgressSpinner,
  ],
})
export class AuthComponent implements OnInit, OnDestroy {
  dataStore = dataStore;
  currentView = signal<'register' | 'login' | 'start' | 'reset-password'>('start');
  loading = signal(true);
  private routeSubscription: Subscription = new Subscription();

  constructor(private router: Router) {}

  ngOnInit(): void {
    // Subscribe to router navigation events to handle view changes
    this.routeSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateCurrentView();
      });

    // Set initial view
    this.updateCurrentView();
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
  }

  private updateCurrentView(): void {
    const url = this.router.url;

    if (url.includes('/auth/login')) {
      this.currentView.set('login');
    } else if (url.includes('/auth/register')) {
      this.currentView.set('register');
    } else if (url.includes('/auth/reset-password')) {
      this.currentView.set('reset-password');
    } else {
      this.currentView.set('start');
    }

    this.loading.set(false);
  }
}
